import React, { useRef, useState } from 'react';
import { Space } from '@gr-monorepo/common/ui';
import { ReactComponent as DoneIcon } from '../images/done.svg';
import { ReactComponent as CopyIcon } from '../images/copy_icon.svg';
import { ButtonStyle, Text, ModalWrap } from './MultiStageOlympModalStyled';
import Modal from 'features/shared/Modal';
import MarkdownPreview from 'features/shared/ui/MarkdownPreview/MarkdownPreview';
import { markdownPrepareTextCopy } from 'utils/markdownCopyText';

const MultiStageOlympModal = ({
  onClose,
  cabmunId,
  textMessageCopy,
  title,
  onCopyClick,
}: {
  onCopyClick: (text: string) => void;
  onClose: () => void;
  cabmunId: number;
  textMessageCopy: string;
  title: string;
}) => {
  const [messageCopied, setMessageCopied] = useState(false);

  const handleClose = () => {
    setMessageCopied(false);
    onClose();
  };

  const handleCopyClick = () => {
    const preparedText = markdownPrepareTextCopy(textMessageCopy, cabmunId);
    navigator?.clipboard?.writeText(preparedText).then(() => {
      setMessageCopied(true);
      onCopyClick(preparedText);
    });
  };

  return (
    <Modal onClose={handleClose} customModalWindow={ModalWrap}>
      <Text style={{ fontSize: '24px', lineHeight: '34px', textAlign: 'center' }}>{title}</Text>
      <Space size={32} axis="vertical" />
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Text style={{ fontSize: '18px', lineHeight: '26px' }}>Скопируйте сообщение и отправьте его школам</Text>
        <Space size={16} axis="vertical" />
        <div
          style={{
            background: '#09152612',
            padding: '24px',
            borderRadius: '8px',
          }}
        >
          <Text
            style={{
              fontSize: '16px',
              fontWeight: '400',
              textAlign: 'left',
            }}
          >
            <MarkdownPreview content={textMessageCopy} replaceUtmTerm={true} />
          </Text>
          <Space size={24} axis="vertical" />
          {messageCopied ? (
            <ButtonStyle style={{ color: '#985EFF' }}>
              <DoneIcon /> <span style={{ marginLeft: '8px' }}>скопировано</span>
            </ButtonStyle>
          ) : (
            <ButtonStyle style={{ color: '#985EFF' }} onClick={handleCopyClick}>
              <CopyIcon />
              cкопировать
            </ButtonStyle>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default MultiStageOlympModal;
